

<!--
<div class="col-sm-12">
    <div class="container">
        <div *ngIf="auth.user | async as user">
            <h1> Hola {{user.displayName}}</h1>
        </div>
        <div class="mb-3 row">
            <form [formGroup]="formsName">
                <label for="staticEmail" class="col-sm-2 col-form-label">test</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" formControlName="name" name="name">
                </div>
            </form>
        </div>
        <button class="btn btn-primary" (click)="editar()">Editar</button>
    </div>
</div>

-->

<div class="container mt-5 ml-2 d-flex justify-content-center">
    <div class="row">
        <div class="col-12 ">
            <div class="card text-white bg-dark mb-3 mx-auto">
                <div class="card-header mx-auto" *ngIf="auth.user | async as user">
                    <h1>{{user.displayName}}</h1>
                </div>
                <div class="card-body">
                  <form [formGroup]="formsName">
                    <div class="row">
                        <div class="col-sm-3">
                            <label for="staticEmail" class="col-form-label">Editar nombre:</label>
                        </div>
                        <div class="col-sm-6 ">
                            <input type="text" class="form-control" formControlName="name" name="name">
                        </div>
                        <div class="col-sm-3 justify-content-right">
                            <button class="btn btn-primary mt-2" (click)="editar()">Editar</button>
                        </div>
                    </div>
                    
                </form>
                </div>
              </div>
        </div>
    </div>
</div>